__turbopack_context__.v({
  "divider": "LineDivider-module-scss-module__bm08Ea__divider",
});
